/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesEventsListAliases {
  ADD_DEVICES_EVENTS_CUSTOM_DYNAMIC_BUTTON = 'add-devices-events-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DATE_PICKER_DATE_END = 'date-picker-date-end',
  DATE_PICKER_DATE_INIT = 'date-picker-date-init',
  DECK_DEVICES_EVENT = 'deck-devices-event',
  DEVICES_EVENTS_CARD = 'devices-events-card',
  FETCH_DEVICES_EVENTS_LIST = 'fetch-devices-events-list',
  FILTER_DEVICES_EVENTS = 'filter-devices-events',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTERED_LIST_DEVICES_EVENTS = 'filtered-list-devices-events',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_DEVICES_EVENTS_LIST = 'layout-devices-events-list',
  LEGENDS_DEVICES_EVENTS = 'legends-devices-events',
}
export { DevicesEventsListAliases };
